export const USERS_API_PREFIX = '/bv/api/v1'
export const ORGANIZATIONS_API_PREFIX = '/bv/api/v1'
export const CALLBACK_PATH = '/auth/callback'
export const LOGOUT_PATH = '/logout'
